import { axios } from "../utils/axios";
const baseUrl = process.env.REACT_APP_API_HOST;

export const getUserDetail = (authToken = "") => {
  authToken =
    authToken === "" || authToken == null
      ? localStorage.getItem("token")
      : authToken;
  try {
    return fetch(`${baseUrl}/users/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    console.log(error);
  }
};

export const getAllocatedUserImageInfo = (id) => {
  try {
    return fetch(`${baseUrl}/users/getAllocatedUserImage?user_id=${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json());
  } catch (error) {
    window.toastr.error(error);
  }
};

export const attendingAPI = (isAttending, user_id) => {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/users/attendances/today?attending=${isAttending}&user_id=${user_id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
    },
  )
    .then((res) => res.json())
    .catch((error) => {
      console.log(error);
    });
};

export const requestAccess = (requestBody) => {
  return fetch(`${process.env.REACT_APP_API_HOST}/users/user-access`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    mode: "cors",
    body: JSON.stringify(requestBody),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.log(error);
    });
};

export const fetchEventsForCalendar = async () => {
  let jsonData;
  try {
    let res;
    res = await axios.get(`${baseUrl}/users/leave-details/me`);
    jsonData = res.data;
  } catch (e) {}
  return jsonData;
};
export const fetchEventsDetailsForCalender = async (user_id, week, year) => {
  let jsonData;
  try {
    let res;
    res = await axios.get(
      `${baseUrl}/users/${user_id}/leaves?month=${week}&year=${year}`,
    );
    jsonData = res;
  } catch (e) {}
  return jsonData;
};

export const deactivateUser = async (id) => {
  let jsonData;
  try {
    let res;
    res = await axios.delete(`${baseUrl}/users/${id}`);
    jsonData = res;
  } catch (e) {}
  return jsonData;
};
export const activateUser = async (id, type) => {
  let jsonData;
  try {
    let res;
    res = await axios.post(`${baseUrl}/users/${id}/${type}`);
    jsonData = res;
  } catch (e) {}
  return jsonData;
};

export const fetchEventsForCalendarByUser = async (id) => {
  let jsonData;
  try {
    let res;
    res = await axios.get(`${baseUrl}/users/user-leave-details/${id}`);
    jsonData = res.data;
  } catch (e) {}
  return jsonData;
};

export const checkUserProcessingChart = async (id) => {
  let jsonData;
  try {
    let res;
    res = await axios.get(`${baseUrl}/users/processing-chart`);
    jsonData = res;
  } catch (e) {}
  return jsonData;
}

export const getNotifications = async ({ offset = 0, limit = 10 }) => {
  let jsonData;
  try {
    let res;
    res = await axios.get(`${baseUrl}/users/notifications?offset=${offset}&limit=${limit}`);
    jsonData = res;
  } catch (e) {}
  return jsonData;
} 

export const markNotificationAsRead = async (id, isRead) => {
  let jsonData;
  try {
    let res;
    res = await axios.put(`${baseUrl}/users/notifications/${id}/read`, { isRead });
    jsonData = res;
  } catch (e) {}
  return jsonData;
}

export const dismissNotification = async (id) => {
  let jsonData;
  try {
    let res;
    res = await axios.put(`${baseUrl}/users/notifications/${id}/dismiss`);
    jsonData = res;
  } catch (e) {}
  return jsonData;
}

export const getNotificationsHistory = async ({ offset = 0, limit = 10 }) => {
  let jsonData;
  try {
    let res;
    res = await axios.get(`${baseUrl}/users/notifications/history?offset=${offset}&limit=${limit}`);
    jsonData = res;
  } catch (e) { }
  return jsonData;
};

export const getNotificationPreferences = async () => {
  let jsonData;
  try {
    let res;
    res = await axios.get(`${baseUrl}/users/notifications/settings`);
    jsonData = res;
  } catch (e) { }
  return jsonData;
};

export const updateNotificationPreferences = async (data) => {
  let jsonData;
  try {
    let res;
    res = await axios.put(`${baseUrl}/users/notifications/settings`, data);
    jsonData = res;
  } catch (e) { }
  return jsonData;
};

